<template>
  <div class="bread_box rel">
    <svg-icon icon-class="home" class="abs icon-home" />
    <el-breadcrumb separator=">" class="bread_content">
      <el-breadcrumb-item
        :to="{
          path:
            '/sourcingFlow?a=' +
            $router.history.current.query.a +
            '&&id=' +
            $router.history.current.query.id
        }"
        >评标室</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="getBreadcrumbData.titname">
        <span>{{getBreadcrumbData.titname }}</span>
        <template v-if="getBreadcrumbData.status">
          <span class="status">({{getBreadcrumbData.status }})</span>
        </template>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "breadcrumb-sourcing",
  props: ["breadcrumbData"],
  computed: {
    getBreadcrumbData() {
      return this.breadcrumbData;
    }
  }
};
</script>

<style scoped>
.rel {
  position: relative;
}
.abs {
  position: absolute;
}
.bread_box {
  background-color: #f1f1f1;
  /*padding-bottom: 10px;*/
}
.bread_content {
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  padding: 0 20px 0 50px;
}
.bread_box .icon-home {
  top: 13px;
  left: 20px;
  width: 17px;
  height: 14px;
}
/deep/.el-breadcrumb .el-breadcrumb__item .el-breadcrumb__inner.is-link {
  color: #9B9B9B!important;;
}

.status {
  color: #FF142F;
  margin-left: 10px;
}
</style>
